import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { map } from 'rxjs';

import { type AddNewRemoteAction, type RemoteAction, type UpdateRemoteAction } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DeviceRemoteActionService {
  private http = inject(HttpClient);

  addNewRemoteAction(data: AddNewRemoteAction) {
    return this.http.post<{ data: RemoteAction; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-remote-actions`, data,
    ).pipe(map(response => response.data));
  }

  updateRemoteAction(deviceId: string, data: Partial<UpdateRemoteAction>) {
    return this.http.patch<{ data: RemoteAction; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-remote-actions/${deviceId}`, data,
    ).pipe(map(response => response.data));

  }

  deleteRemoteAction(deviceId: string) {
    return this.http.delete(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-remote-actions/${deviceId}`,
    );
  }

  remoteActionList(deviceId: string) {
    const params = new HttpParams().set('deviceId', deviceId);

    return this.http.get<{ data: RemoteAction[]; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-remote-actions`,
      { params },
    ).pipe(map(response => response.data));

  }

  deviceRemoteActions(actionId: string) {
    return this.http.get<{ data: RemoteAction[]; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-remote-actions/${actionId}`,
    ).pipe(map(response => response.data));
  }

  executeRemoteAction(config: { deviceId: string, remoteActionPointId: string, value: string; }) {
    return this.http.post<{ data: RemoteAction; }>(
      `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/devices/${config.deviceId}/execute-remote/${config.remoteActionPointId}`,
      { value: config.value },
    ).pipe(map(response => response.data));
  }
}
